import Vue from "vue";
import Vuex from "vuex";
import SetState from "~~/store/modules/SetState";
import Cart from "@/store/modules/Cart";
import Query from "~~/store/helpers/Query.js";
import Url from "~~/store/helpers/Url.js";
import Validator from "~~/store/helpers/Validator.js";
import Number from "~~/store/helpers/Number.js";
import Storage from "~~/store/helpers/Storage.js";
import { getGroups, getGroup, getCatalog } from "~~/services/CrmService.js";
import { addRelFiles } from "~~/services/MediaService.js";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    SetState,
    Query,
    Cart,
    Storage,
    Url,
    Validator,
    Number,
  },
  /**
   * Глобльное состояние приложения
   */
  state: {
    cat: {},
    catDesc: {},
    products: {},
    articles: {
      items: [
        {
          id: 1,
          title: "Нужно ли закрывать фундамент на зиму?",
          date: "24.12.2019",
          text: `<p>Lorem 12 Ipsum является стандартной для текстов на латинице с начала XVI века.
               В то время некий безымянный печатник создал большую коллекцию размеров и форм шрифтов,
                используя Lorem Ipsum для распечатки образцов. Lorem Ipsum не только успешно пережил
                 без заметных изменений пять веков, но и перешагнул в электронный дизайн. Его популяризации
                  в новое время послужили публикация листов Letraset с образцами Lorem Ipsum в 60-х годах и,
               в более недавнее время, программы электронной вёрстки типа Aldus PageMaker, в шаблонах которых
                используется Lorem Ipsum.</p>`,
        },
        {
          id: 2,
          date: "25.12.2019",
          title: "Гидроизоляция подвала изнутри своими руками",
          text: `<p>Lorem 3443 Ipsum является стандартной для текстов на латинице с начала XVI века.
              В то время некий безымянный печатник создал большую коллекцию размеров и форм шрифтов,
               используя Lorem Ipsum для распечатки образцов. Lorem Ipsum не только успешно пережил
                без заметных изменений пять веков, но и перешагнул в электронный дизайн. Его популяризации
                 в новое время послужили публикация листов Letraset с образцами Lorem Ipsum в 60-х годах и,
              в более недавнее время, программы электронной вёрстки типа Aldus PageMaker, в шаблонах которых
               используется Lorem Ipsum.</p>`,
        },
        {
          id: 3,
          date: "26.12.2019",
          title: "Бытовая химия в бетоне: заблуждения и последствия",
          text: `<p>Lorem 4545 Ipsum является стандартной для текстов на латинице с начала XVI века.
              В то время некий безымянный печатник создал большую коллекцию размеров и форм шрифтов,
               используя Lorem Ipsum для распечатки образцов. Lorem Ipsum не только успешно пережил
                без заметных изменений пять веков, но и перешагнул в электронный дизайн. Его популяризации
                 в новое время послужили публикация листов Letraset с образцами Lorem Ipsum в 60-х годах и,
              в более недавнее время, программы электронной вёрстки типа Aldus PageMaker, в шаблонах которых
               используется Lorem Ipsum.</p>`,
        },
      ],
      total: 21,
    },
    videoLinks: [
      {
        label: "Видео по материалам для паркета",
        to: {
          name: "video",
          params: {
            id: 1,
          },
        },
      },
      {
        label: "Видео клеям и герметикам",
        to: {
          name: "video",
          params: {
            id: 2,
          },
        },
      },
      {
        label: "Видео по гидроизоляции",
        to: {
          name: "video",
          params: {
            id: 3,
          },
        },
      },
      {
        label: "Видео по отделке стен и фасадов",
        to: {
          name: "video",
          params: {
            id: 4,
          },
        },
      },
      {
        label: "Видео по добавкам в бетон",
        to: {
          name: "video",
          params: {
            id: 5,
          },
        },
      },
      {
        label: "Видео по подливочным составам и анкеровкам",
        to: {
          name: "video",
          params: {
            id: 6,
          },
        },
      },
      {
        label: "Обучающий курс компании Sika и FORUMHOUSE",
        to: {
          name: "video",
          params: {
            id: 7,
          },
        },
      },
    ],
  },

  mutations: {
    saveCat(store, cat) {
      store.cat = cat;
    },
    saveCatDesc(store, { groupId, description }) {
      Vue.set(store.catDesc, groupId, description);
    },
    saveProducts(store, { groupId, products, total }) {
      if (!store.products[groupId]) {
        Vue.set(store.products, groupId, {});
      }
      Vue.set(store.products[groupId], "items", products);
      if (total) {
        Vue.set(store.products[groupId], "total", total);
      }
    },
  },

  actions: {
    async fetchCat({ state, commit }, { params, reload }) {
      if (reload || Vue._.isEmpty(state.cat)) {
        const response = await getGroups(params);
        let groupList = {};
        for (const group of response.data.data) {
          groupList[group.id] = group;
        }
        commit("saveCat", groupList);
      }
    },

    async fetchCatDesc({ state, commit }, { groupId }) {
      if (!state.catDesc[groupId]) {
        const response = await getGroup(groupId);
        commit("saveCatDesc", {
          groupId: groupId,
          description: response.data.data,
        });
      }
    },

    async fetchProducts({ state, commit }, { groupId, params, reload }) {
      if (reload || !state.products[groupId]) {
        const response = await getCatalog(groupId, { ...params, per_page: 40 });
        let products = response.data.data;

        commit("saveProducts", {
          groupId: groupId,
          products: products,
          total: response.data.meta.total,
        });
      }
    },

    async fetchRel({ state, commit }, { groupId, reload }) {
      let products = state.products[groupId].items;
      if (reload || !products[0] || !products[0].fileCovers.length) {
        products = await addRelFiles(products, [
          { attr: "fileCovers", isVideo: false },
        ]);
        commit("saveProducts", {
          groupId: groupId,
          products: products,
        });
        products = await addRelFiles(products, [
          { attr: "fileImgs", isVideo: false },
        ]);
        commit("saveProducts", {
          groupId: groupId,
          products: products,
        });
        products = await addRelFiles(products, [
          { attr: "fileDocs", isVideo: false },
        ]);
        products = await addRelFiles(products, [
          { attr: "video", isVideo: true },
        ]);
        commit("saveProducts", {
          groupId: groupId,
          products: products,
        });
      }
    },
  },
});
